import http from '../utils/http'

export function getTagInfo (params) {
  return http.get('/dailyStrategy/getTagInfoForDailyBackTest', params)
}

export function frontLog (params) {
  return http.post('/log/frontLog', params)
}

// 增加一个函数，可以放入router路径， 比如令routerName='dailyStrategy', 则会将url拼接成/dailyStrategy/+函数名
var out = {}
export function getData (getFuncName, params, result, delay, life, _this, callback = function () {}) {
  getDailyStrategyRequest(getFuncName, params).then(function (x) {
    if ((out.hash_code && out.hash_code === params.hash_code) || (out.benchmark_hash_code && out.benchmark_hash_code === params.benchmark_hash_code)) {
      return
    } else {
      out = {}
    }
    var dataReady = true
    var toReload = false
    var returnData = Object.keys(result)
    var thisVariables = []
    for (var q = 0; q < returnData.length; q++) {
      thisVariables.push(result[returnData[q]])
    }
    if (!x.data.data) {
      if (x.data.message) {
        _this.timerList = []
        dataReady = false
        toReload = false
        callback(_this)
      } else if (life === 0) {
        _this['fileStatus'] = {
          statusMsg: '服务器繁忙，请稍后再试',
          name: getFuncName,
          params: params
        }
        _this.timerList = []
        dataReady = true
        toReload = false
        frontLog({
          url: getFuncName,
          params: JSON.stringify(params),
          err_type: 'time-out',
          err_msg: '响应超时'}).then(function (x) {})
        callback(_this)
      } else {
        dataReady = false
        toReload = true
      }
    } else {
      if (x.data.data.status && x.data.data.status === 'fail') {
        dataReady = true
        toReload = false
        _this['fileStatus'] = {
          statusMsg: x.data.data.statusMsg,
          name: getFuncName,
          params: params
        }
        out = params
        callback(_this)
      } else {
        for (var i = 0; i < returnData.length; i++) {
          if (returnData[i] !== 'fileStatus') {
            if (returnData[i] in x.data.data === false) {
              dataReady = false
              toReload = true
            } else {
              if (x.data.data[returnData[i]] === null) {
                dataReady = false
                toReload = true
              }
            }
          }
        }
      }
      if ('drop' in x.data.data) {
        if (x.data.data['drop'] === true) {
          _this['drop_message_' + getFuncName] = x.data.data['drop_message']
          dataReady = false
          toReload = false
        }
      }
    }
    if (dataReady) {
      for (var j = 0; j < returnData.length; j++) {
        if (returnData[j] !== 'fileStatus') {
          _this[thisVariables[j]] = x.data.data[returnData[j]]
        }
      }
      callback(_this)
    } else {
      if (toReload === true) {
        if (typeof _this.timerList === 'undefined') {
          _this.timerList = []
        }
        _this.timerList[getFuncName] = setTimeout(() => { getData(getFuncName, params, result, delay * 1.2, life - 1, _this, callback) }, delay)
      } else {
      }
    }
  })
}

export function getDataWithStatus (getFuncName, timeName, params, result, delay, life, _this, callback = function () {}) {
  getRequest(getFuncName, params).then(function (x) {
    var dataReady = true
    var toReload = false
    if (life === 0) {
      _this['fileStatus'] = {
        statusMsg: '服务器繁忙，请稍后再试',
        name: timeName
      }
      _this.timerList = []
      dataReady = false
      toReload = false
      frontLog({
        url: getFuncName,
        params: JSON.stringify(params),
        err_type: 'time-out',
        err_msg: '响应超时'}).then(function (x) {})
      callback(_this)
    }
    if (!x.data.data) {
      if (x.data.message) {
        _this.timerList = []
        dataReady = false
        toReload = false
        callback(_this)
      } else {
        dataReady = false
        toReload = true
      }
    } else {
      if ('status' in x.data.data) {
        if (x.data.data['status'] !== 'running') {
          if (x.data.data['status'] === 'bad') {
            _this['fileStatus'] = {
              statusMsg: x.data.data.statusMsg,
              name: timeName,
              params: params,
              status: 'bad'
            }
            _this.timerList = []
            dataReady = false
            toReload = false
            callback(_this)
          } else {
            dataReady = true
            toReload = false
          }
        } else {
          dataReady = false
          toReload = true
        }
      } else {
        dataReady = true
        toReload = false
      }
    }
    if (dataReady) {
      for (let j = 0; j < result.length; j++) {
        if (result[j] !== 'fileStatus') {
          _this[result[j]] = x.data.data
          _this.timerList = []
        }
      }
      callback(_this)
    } else {
      if (toReload) {
        if (typeof _this.timerList === 'undefined') {
          _this.timerList = []
        }
        _this.timerList[timeName] = setTimeout(() => { getDataWithStatus(getFuncName, timeName, params, result, delay * 1.2, life - 1, _this, callback) }, delay)
      }
    }
  })
}

export function getTagArea (params, _this, delay) {
  getDailyStrategyRequest('getTagArea', params).then(function (x) {
    var dataReady = true
    if (!x.data.data) {
      dataReady = false
    } else {
      if ('labels' in x.data.data === false) {
        dataReady = false
      }
      if ('period_macro_tag_area' in x.data.data === false) {
        dataReady = false
      }
    }
    if (dataReady) {
      _this['tagAreaInfo'] = x.data.data
    } else {
      if (typeof _this.timerList === 'undefined') {
        _this.timerList = []
      }
      _this.timerList['getTagArea'] = setTimeout(() => { getTagArea(params, _this, delay * 1.2) })
    }
  })
}

// 通用接口
export function getDailyStrategyRequest (requestName, params) {
  return http.get('/dailyStrategy/' + requestName, params)
}

export function postDailyStrategyRequest (requestName, params) {
  return http.post('/dailyStrategy/' + requestName, params)
}

export function getRequest (requestName, params) {
  return http.get(requestName, params)
}

export function postRequest (requestName, params) {
  return http.post(requestName, params)
}



// WEBPACK FOOTER //
// ./src/api/dailyBackTest.js